import { useMemo } from 'react'

import { useAppSelector } from 'hooks/reduxHooks'
import { isBannerHiddenForPath } from 'lib/routing/routeVisibility'

import type { HideableBanner } from 'constants/routeVisibilityConfig'

export function useIsBannerHidden(banner: HideableBanner): boolean {
  const currentPath = useAppSelector(state => state.router.location.pathname)

  return useMemo(() => {
    return isBannerHiddenForPath(currentPath, banner)
  }, [currentPath, banner])
}
